export const fontSize = {
    mainHeading: `${"5.2em"}`,
    title: `${"3em"}`,
    text: `${"1.2em"}`,
    titleMobile: `${"2.5em"}`,
    textMobile: `${"1.2em"}`,
};